// extracted by mini-css-extract-plugin
export default {"offCanvas":"styles_offCanvas__VrgHB","navbar":"styles_navbar__l8aXd","navLinks":"styles_navLinks__Q5WbO","navbarBrand":"styles_navbarBrand__34WWL"};